module.exports = __webpack_public_path__ + "img/TC.729aa511.svg";